import type { ITransactionRecurrence, RioTrip } from "@types";

export const TRANSACTION_PAGE_SIZE = 10;

export const MAX_DRIVERS = 3;

export interface TransactionDriverSummary {
  id?: string | null;
  name?: string | null;
}

export interface TransactionTableItem {
  driverIds: string[] | null;
  driverId?: string | null;
  drivers?: TransactionDriverSummary[] | null;
  id: string;
  transactionDate: string;
  amount: number;
  branchName: string;
  segmentBussinessName: string | null;
  clientName: string | null;
  supplierClientName?: string | null;
  vehiclePlate: string | null;
  vehicleId?: string | null;
  driverName: string | null;
  categoryName: string;
  subcategoryName: string;
  taxPercentage: string | number;
  status?: string | null;
  dueDate?: string | null;
  recurrenceId?: string | null;
  recurrence?: ITransactionRecurrence | null;
  source?: string | null;
  tripCode?: string | null;
  trip?: RioTrip | null;
  paymentMethod?: string | null;
  locked?: boolean;
  lockedReasons?: string[] | null;
}

const firstFilledId = (values: Array<string | null | undefined>): string | null =>
  values.find((value) => typeof value === "string" && value.trim().length > 0)?.trim() ?? null;

export const resolveTripDriverId = (item: TransactionTableItem): string | null =>
  firstFilledId([
    item.trip?.driverId,
    ...(item.drivers?.map((driver) => driver?.id) ?? []),
    ...(item.driverIds ?? []),
    item.driverId,
  ]);

export const resolveMomentLocale = (locale: string): string => {
  if (locale.startsWith("en")) return "en-gb";
  if (locale.startsWith("es")) return "es";
  return "pt-br";
};

export const resolveFetchContextLabel = (index: number): string => {
  if (index === 0) return "dashboard";
  if (index === 1) return "tabela";
  return "kpis do mês anterior";
};

export const deriveTotalRecords = (payload: any, fallback: number): number => {
  const candidates = [
    payload?.totalElements,
    payload?.total,
    payload?.totalRecords,
    payload?.totalItems,
    payload?.totalReceitas,
    payload?.totalDespesas,
    payload?.meta?.totalElements,
    payload?.meta?.total,
    payload?.data?.totalElements,
    payload?.data?.total,
  ];

  const found = candidates.find((value) => typeof value === "number");

  return typeof found === "number" ? found : fallback;
};
